export const DEFAULT_DESKTOP_PAGE_SIZE = 24
export const DEFAULT_MOBILE_PAGE_SIZE = 24
